import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const ManageModal = ({ tag, onChange, onSubmit, show, onHide, onDelete }) => {
  return (
    <form onSubmit={onSubmit}>
      <Modal isOpen={show} toggle={onHide}>
        <ModalHeader toggle={onHide}>Manage Tag</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="tag">Tag</label>
            <input
              type="text"
              className="form-control"
              name="tag"
              value={tag}
              onChange={onChange}
              autoFocus
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger" onClick={onDelete}>
            <i className="fa fa-times-circle" /> Delete
          </button>

          <button type="submit" className="btn btn-success" onClick={onSubmit}>
            <i className="fa fa-check-circle" /> Save
          </button>
        </ModalFooter>
      </Modal>
    </form>
  );
};

export default ManageModal;



// WEBPACK FOOTER //
// ./src/pages/Tags/ManageModal.jsx